// Claude 対話API呼び出し（Cloudflare Pages Function経由）
// MVPでは Pages Function が未配備でも動くよう、フォールバック実装も同居

import { AppSettings, ReactionVerdict } from '../types';

export interface ClaudeAnalyzeResult {
  verdict: ReactionVerdict;
  reply: string;
}

/**
 * 子どもの応答を解釈し、verdict + 返事を生成する
 * Pages Function `/api/chat` が利用可能ならそれ経由、なければ単純ルールでフォールバック
 */
export async function analyzeReply(
  childReply: string,
  taskTitle: string,
  systemPrompt: string,
  settings: AppSettings
): Promise<ClaudeAnalyzeResult> {
  const apiBase = settings.apiBase || '';
  // Pages Function があれば呼ぶ
  if (apiBase || typeof window !== 'undefined') {
    try {
      const res = await fetch(`${apiBase}/api/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          systemPrompt,
          userMessage: childReply || '(無音)',
          taskTitle,
        }),
      });
      if (res.ok) {
        const data = await res.json();
        if (data && typeof data === 'object' && 'verdict' in data) {
          return {
            verdict: data.verdict as ReactionVerdict,
            reply: data.reply || '',
          };
        }
      }
    } catch (err) {
      console.warn('[claude.analyzeReply] API失敗、フォールバック使用', err);
    }
  }
  // フォールバック: 簡易ルール判定
  return fallbackAnalyze(childReply, taskTitle);
}

function fallbackAnalyze(reply: string, taskTitle: string): ClaudeAnalyzeResult {
  const text = (reply || '').trim();
  if (!text) {
    return { verdict: 'silent', reply: '聞こえなかったかな。もう一度言うね。' };
  }
  // 肯定パターン
  if (/(はい|うん|やる|やってる|わかった|オッケー|おっけー|ok|了解|できた)/i.test(text)) {
    return { verdict: 'positive', reply: 'えらいね、その調子！' };
  }
  // 否定パターン
  if (/(やだ|いや|無理|あとで|まだ|やらない|嫌)/i.test(text)) {
    return { verdict: 'negative', reply: `そっか。でも${taskTitle}の時間だよ。一緒にやってみよう。` };
  }
  return { verdict: 'ambiguous', reply: 'もう少しで時間だから準備しようね。' };
}
